import { Element } from "@api/models/Element";
import { LanguagesService } from "@share/common/services/LanguagesService";
import { filterObjectKeys } from "@common/ObjectsHelper";
import { SchemaSettings } from "@api/models/objects/SchemaSettings";
import { DateTime } from "luxon";

export class MultiLanguageObject<T extends Element> {
    constructor(
        public readonly languageService: LanguagesService,
        public data: { [lang: string]: T },
        public readonly schemaSettings: SchemaSettings<T>
    ) { }

    get base() {
        return this.data[this.languageService.baseLanguage] || null;
    }

    get localizedData() {
        return this.data[this.languageService.selected] || null;
    }

    get userLangData() {
        return this.data[this.languageService.userLanguage] || null;
    }

    get userLangForSave() {
        return filterObjectKeys(this.userLangData, this.getFillableFieldsForLanguage(this.languageService.userLanguage));
    }

    get languagesData() {
        const result: Record<string, T> = {};

        for (const language of this.languageService.languagesWithoutUsersOne) {
            result[language] = filterObjectKeys(
                this.data[language] || {},
                this.getFillableFieldsForLanguage(language)
            );
        }

        return result;
    }

    setUpdatedAt(newDate: string | DateTime) {
        if (this.base?.updatedAt) {
            this.base.updatedAt = newDate as any;
        }
    }

    //@todo remove that peculiar code when the backend update method is fixed
    private getFillableFieldsForLanguage(lang: string) {
        return this.languageService.baseLanguage == lang
            ? this.schemaSettings.fillabelFields
            : this.schemaSettings.fillableLocalizableFields();
    }

}
